import { useEffect } from 'react'
import Toggles from '@domain/toggles/Toggles'

import Config from '@/config'
import { getURL } from '@/utils'
import { buildSignupForward } from '@/utils/signupForward'

/** Origin of a URL that may come as a full URL (PRO config) or as subdomain + path (docker envs). */
const toOrigin = (url) => {
	try {
		return new URL(url, window.location.href).origin
	} catch {
		return ''
	}
}

/**
 * DV-6559 — Listener global que reenvía el registro a la web que nos embebe
 * (join.vibia.com). Se monta en `App` y no en un componente de auth concreto:
 * la vista embebible `/product-info-download` (Flujo 2 del briefing) no monta
 * `ModalAuth`, así que un listener por componente dejaría fuera justo el caso
 * que Marketing necesita.
 *
 * No hace nada si la app no está embebida (`window.parent === window`), lo que
 * cubre el uso normal de app.vibia.com y evita reenviarnos el mensaje a nosotros
 * mismos. El push al dataLayer propio lo sigue haciendo `signupDataLayer` (DV-6394).
 */
const useSignupForward = () => {
	useEffect(() => {
		if (!Toggles.isEnabled('firstPartyDataLayerSecondIt')) return
		if (window.parent === window) return

		const config = Config.getInstance()
		// Mismo cálculo que ModalAuth: en PRO el endpoint trae la URL completa y NO trae
		// subdominio; en los entornos dockerizados es lo contrario (url vacía + subdominio).
		const authOrigin = toOrigin(
			getURL(config?.getConfig('endpoints.fr-auth.url') ?? '', config?.getConfig('endpoints.fr-auth.subdomain'))
		)
		const landingOrigin = toOrigin(getURL('', 'join'))
		const selfOrigin = window.location.origin

		const handleMessage = (event) => {
			const forward = buildSignupForward({
				data: event.data,
				origin: event.origin,
				selfOrigin,
				authOrigin,
				landingOrigin,
				isEmbedded: true
			})
			if (!forward) return

			forward.targets.forEach((target) => window.parent.postMessage(forward.envelope, target))
		}

		window.addEventListener('message', handleMessage)
		return () => window.removeEventListener('message', handleMessage)
	}, [])
}

export default useSignupForward
